import { IconSize } from 'constants/coreDesignSystem';

export const COPY_ICON_SIZE = IconSize[14];

export const COPY_FEEDBACK_DURATION_MS = 1_500;
